import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

import { IconClose } from 'components/Icons/IconClose'

const CloseButtonStyled = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`
const StyledToastContainer = styled(ToastContainer).attrs({})`
  .Toastify__toast-container {
  }
  .Toastify__toast {
    padding: 16px;
    background-color: ${p => p.theme.colors.background.primary};
    color: ${p => p.theme.colors.text.primary};
    border-radius: 4px;
    font-size: ${p => p.theme.typography.size.Description}px;
    font-weight: ${p => p.theme.typography.weight.Medium};
    font-family: ${p => p.theme.typography.family.Poppins};
    margin-top: 70px;
    @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
      width: 552px;
      margin-left: -300px;
    }
  }
  .Toastify__toast-body {
  }
`

const CloseButton = ({ closeToast }: { closeToast: (e: React.MouseEvent<HTMLElement>) => void }) => {
  return (
    <CloseButtonStyled onClick={closeToast}>
      <IconClose />
    </CloseButtonStyled>
  )
}

export const Toast = () => {
  return (
    <StyledToastContainer
      position="top-right"
      autoClose={4000}
      closeButton={props => <CloseButton closeToast={props.closeToast} />}
    />
  )
}
